<template>
  <div class="page-container">
    <div v-if="getAssets.images.finish.logo" class="logo-container">
      <img :src="getAssets.images.finish.logo" alt="logo" />
    </div>

    <h1 :style="{ color: getColor }" class="mt-9 mb-3">{{ getTexts.title }}</h1>
    <h2>{{ getTexts.description }}</h2>

    <div v-if="!isConfirm" class="grid-items" :class="gridClass">
      <div v-if="hasStores" class="grid-item download-app">
        <div class="img-text">
          <download-svg :color="getColor" />
          <p :style="{ color: getColor }" class="mb-0 mt-5">Baixe o app!</p>
        </div>
        <div class="stores">
          <div class="stores-items d-flex align-center justify-center">
            <qr-code-button
              v-if="['android', 'desktop'].includes(operatingSystem) && APP_STORES.play_store_link"
              :link="APP_STORES.play_store_link"
              variant="playstore"
            />
            <qr-code-button
              v-if="['ios', 'desktop'].includes(operatingSystem) && APP_STORES.app_store_link"
              :link="APP_STORES.app_store_link"
              variant="apple"
            />
          </div>
          <p>Escaneie o QR code com o celular para baixar o app.</p>
        </div>
      </div>

      <div class="grid-item send-msg">
        <div class="img-text">
          <channels-svg :color="getColor" />
          <p :style="{ color: getColor }">{{ getMessage }}</p>
        </div>
        <div v-if="getWhatsapp.enable_whatsapp_link" class="d-flex justify-center">
          <qr-code-button variant="whatsapp" :link="getWhatsapp.whatsapp_link" />
        </div>
      </div>

      <div v-if="!isConsumerActivation" class="grid-item supermarket-cashier">
        <div class="img-text">
          <cashier-svg :color="getColor" />
          <p :style="{ color: getColor }">Identifique suas compras informando seu CPF no caixa para aproveitar todas as vantagens</p>
        </div>
      </div>
    </div>

    <div class="action-button">
      <v-btn class="custom-button" :color="getColor" @click="goBack">Voltar para o início</v-btn>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import QrCodeButton from '../components/QrCodeButton.vue'
import DownloadSvg from '../components/svgs/DownloadSvg.vue'
import ChannelsSvg from '../components/svgs/ChannelsSvg.vue'
import CashierSvg from '../components/svgs/CashierSvg.vue'

export default {
  components: { QrCodeButton, DownloadSvg, ChannelsSvg, CashierSvg },
  data() {
    return {
      isValidatingToken: true
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS', 'FINISH_SCREEN_WHATSAPP', 'APP_STORES', 'ALLOWED_MODULES']),
    gridClass() {
      if (this.isConsumerActivation && this.hasStores) {
        return 'grid-2-stores'
      } else return this.hasStores ? 'grid-3' : 'grid-2-cashier'
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle
    },
    getAssets() {
      return this.GET_ASSETS
    },
    getColor() {
      return this.getAssets.colors.finish.main || this.getAssets.colors.form.buttonBackground
    },
    getWhatsapp() {
      return this.FINISH_SCREEN_WHATSAPP
    },
    getAppStores() {
      return this.APP_STORES
    },
    getMessage() {
      if (this.getWhatsapp.enable_whatsapp_link) return 'Mande uma mensagem para nosso Whatsapp e receba todas as novidades e ofertas do clube!'
      return 'Fique atento nos canais de comunicação para saber das novidades e ofertas do clube!'
    },
    hasStores() {
      return this.getAppStores.enable_apps && (this.getAppStores.app_store_link || this.getAppStores.play_store_link)
    },
    operatingSystem() {
      const userAgent = navigator.userAgent.toLowerCase()

      if (/android/.test(userAgent)) return 'android'
      else if (/iphone|ipad|ipod/.test(userAgent)) return 'ios'
      else return 'desktop'
    },
    isConfirm() {
      return this.$route.path === '/confirm'
    },
    isConsumerActivation() {
      return this.ALLOWED_MODULES.consumer_activation_after_sign_up
    },
    getTexts() {
      if (this.isConfirm) {
        if (this.isValidatingToken) {
          return {
            title: 'VALIDANDO TOKEN DO USUÁRIO...',
            description: ''
          }
        } else {
          return {
            title: 'TOKEN INVÁLIDO',
            description: 'Seu token de usuário é inválido ou está expirado.'
          }
        }
      } else {
        const { confirmed, nome } = this.$route.query

        if (this.isConsumerActivation && nome) {
          return {
            title: 'Sua validação de cadastro ainda está pendente!',
            description: ''
          }
        } else if (nome || confirmed) {
          const title = confirmed ? 'PARABÉNS' : `PARABÉNS, ${this.$route.query.nome.trim().toUpperCase()}`
          return {
            title,
            description: 'Cadastro concluído! Agora os próximos passos:'
          }
        } else {
          return {
            title: 'TUDO CERTO!',
            description: `Seus dados foram atualizados com sucesso. Não se esqueça de se identificar com seu ${this.getDocType} no caixa para receber os descontos do clube.`
          }
        }
      }
    },
    getDocType() {
      return this.$store.state.userInfo.person_type === 'N' ? 'CPF' : 'CNPJ'
    }
  },
  watch: {
    isIdle() {
      if (this.isIdle) this.goBack()
    }
  },
  async mounted() {
    const { token } = this.$route.query
    if (token) await this.validateToken(token)
  },
  beforeDestroy() {
    this.$store.commit('USER_INFO', {})
    this.$store.commit('ACCESS_TOKEN', null)
  },
  methods: {
    ...mapActions(['signUpConfirmationByLink']),
    goBack() {
      this.$router.push({ path: '/home' })
    },
    async validateToken(token) {
      const { wasConfirmated } = await this.signUpConfirmationByLink({ token })
      if (wasConfirmated) {
        this.$router
          .push({
            path: '/finalizar',
            query: { confirmed: true }
          })
          .catch(() => {})
      } else {
        this.isValidatingToken = false
      }
    }
  }
}
</script>

<style lang="scss">
.page-container {
  max-width: 1056px;
  margin: 0 auto;
  height: 100%;
  padding: 36px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .logo-container {
    max-width: 140px;
    height: 140px;
    display: flex;
    align-items: center;

    img {
      display: block;
      width: 100%;
    }
  }

  h1 {
    font-weight: 700;
    font-size: 28px;
    text-align: center;
  }

  h2 {
    color: #4b525a;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 48px;
    text-align: center;
  }

  .grid-3 {
    grid-template-columns: repeat(3, 330px);

    .send-msg {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        height: 274px;
        width: 1px;
        background-color: #b4bac0;
        right: -48px;
        top: 0;
      }
      &::before {
        content: '';
        position: absolute;
        height: 274px;
        width: 1px;
        background-color: #b4bac0;
        left: -48px;
        top: 0;
      }
    }
  }

  .grid-2-stores {
    grid-template-columns: repeat(2, 330px);
    justify-content: center;

    .download-app {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        height: 274px;
        width: 1px;
        background-color: #b4bac0;
        right: -48px;
        top: 0;
      }
    }
  }
  .grid-2-cashier {
    grid-template-columns: repeat(2, 330px);
    justify-content: center;

    .send-msg {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        height: 274px;
        width: 1px;
        background-color: #b4bac0;
        right: -48px;
        top: 0;
      }
    }
  }

  .grid-items {
    display: grid;
    grid-template-rows: 444px;
    gap: 102px;

    p {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }

    .grid-item {
      text-align: center;
      position: relative;
      height: 100%;

      .img-text {
        height: 232px;
        margin-bottom: 20px;
      }

      .stores {
        .stores-items {
          .qr-code-button-outside {
            margin: 0 4px;
          }
        }

        p {
          color: #78838e;
          font-weight: 400;
          font-size: 14px;
          margin: 8px auto 0;
          max-width: 244px;
          text-align: center;
          line-height: 1.2;
        }
      }
    }
  }
}

.action-button {
  margin-top: 42px;

  .custom-button {
    text-transform: unset !important;
    letter-spacing: 0.02px !important;
    color: #fff;
    padding: 12px 32px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    width: 216px;
    height: 43px !important;
    box-shadow: none;
  }
}

@media screen and (max-width: 1260px) {
  .page-container {
    .grid-items {
      grid-template-columns: 330px !important;
      gap: 100px;
    }

    .send-msg {
      &::after {
        display: none;
      }
      &::before {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .page-container {
    padding-inline: 36px;

    .grid-items {
      grid-template-rows: 300px;
    }

    .stores {
      p {
        display: none;
      }
    }
  }
}
</style>
